import { injectIntl } from 'react-intl';
import DataTable from '../../../../core/components/DataTable';
import '../../../../styles/manage-users.scss';
import { IntlType } from '../../../../utils/typing';
import { useUsersTableProps } from './hooks/useUsersTableProps';
import IncludeArchivedCheckbox from './IncludeArchivedCheckbox';
import ManageUsersHeader from './ManageUsersHeader';
import { getApiStatus } from '../../../../core/utils';
import { useSelector } from 'react-redux';
import { FETCH_EMPLOYEES } from '../../../employees/actions';
import Loader from '../../../../core/components/Loader';

interface Props {
  intl: IntlType;
}

const ManageUsers = ({ intl }: Props) => {
  const { setSearchParams, ...tableProps } = useUsersTableProps(intl);
  const isEmployeesLoading = useSelector((state) => getApiStatus(state, FETCH_EMPLOYEES));

  const handleIncludeArchived = (event: React.ChangeEvent<HTMLInputElement>) => {
    setSearchParams({
      includeArchived: event.target.checked,
    });
  };

  return (
    <>
      <ManageUsersHeader intl={intl} />
      <IncludeArchivedCheckbox intl={intl} handleChange={handleIncludeArchived} />
      {isEmployeesLoading ? <Loader /> : <DataTable {...tableProps} />}
    </>
  );
};

export default injectIntl(ManageUsers);
